var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArmchair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#b27033;}.cls-2{fill:#976332;}.cls-3{fill:#f2a156;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_536",
    "data-name": "Warstwa 536"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_539",
    "data-name": "Warstwa 539"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.81,19.17h-9.3a4.37,4.37,0,0,1-4.36-4.36V10.53a4.37,4.37,0,0,1,4.36-4.36h9.3a4.38,4.38,0,0,1,4.36,4.36v4.28A4.38,4.38,0,0,1,20.81,19.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.76,18.91H11.45a4.31,4.31,0,0,1-4.3-4.3s3,.48,4,.56a90.16,90.16,0,0,0,10,0c1-.07,3.89-.56,3.89-.56A4.31,4.31,0,0,1,20.76,18.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M20.81,6.17h-9.3a4.37,4.37,0,0,0-4.36,4.36v1a4.37,4.37,0,0,1,4.36-4.36h9.3a4.38,4.38,0,0,1,4.36,4.36v-1A4.38,4.38,0,0,0,20.81,6.17Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.19,
    y: 16.17,
    width: 3.98,
    height: 10.99,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.17,
    y: 16.17,
    width: 4,
    height: 11,
    rx: 1,
    transform: "translate(50.33 43.34) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 23.17,
    y: 14.79,
    width: 6,
    height: 4.38,
    rx: 2.08,
    transform: "translate(52.33 33.96) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.17,
    y: 14.79,
    width: 6,
    height: 4.38,
    rx: 2.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9.17,
    y: 16.99,
    width: 14,
    height: 9.18,
    rx: 3.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.17,
    y: 22.17,
    width: 14,
    height: 5,
    rx: 1.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 12.17,
    cy: 11.17,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 20.17,
    cy: 11.17,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.87,17H12.46a3.3,3.3,0,0,0-3.29,3.3v1.17a3.3,3.3,0,0,1,3.29-3.29h7.41a3.3,3.3,0,0,1,3.3,3.29V20.29A3.3,3.3,0,0,0,19.87,17Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmchair);
export default __webpack_public_path__ + "static/media/armchair.99dea0e8b73c2ad3f42ca77d7c32f731.svg";
export { ForwardRef as ReactComponent };